[
	{
		"name": "Arizona",
		"abbreviation": "AZ"
	},
	{
		"name": "Idaho",
		"abbreviation": "ID"
	},
	{
		"name": "Montana",
		"abbreviation": "MT"
	},
	{
		"name": "Oregon",
		"abbreviation": "OR"
	},
	{
		"name": "Utah",
		"abbreviation": "UT"
	},
	{
		"name": "Washington",
		"abbreviation": "WA"
	},
	{
		"name": "Wyoming",
		"abbreviation": "WY"
	}
]
